module.exports = __webpack_public_path__ + "static/media/fr_FR.79af641a.png";